<p class="tooltip">
  {{ tooltipText }}
</p>
